export default __webpack_public_path__ + "static/media/BASSETS-5.c170f2aa.png";